<template>
  <div
    class="toast-container position-fixed top-0 end-0 p-3"
    style="z-index: 1090"
  >
    <TransitionGroup name="toast">
      <div
        v-for="msg in flash.messages"
        :key="msg.id"
        class="toast align-items-center border-0 show"
        :class="`text-bg-${msg.type}`"
        role="alert"
      >
        <div class="d-flex">
          <div class="toast-body">
            {{ msg.message }}
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            @click="flash.dismiss(msg.id)"
          />
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { useFlashStore } from "@/stores/flash";
const flash = useFlashStore();
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(30px);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
